import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "../../../../environments/environment";
import * as XLSX from "xlsx";
import { Subject } from "rxjs";

@Component({
  selector: "app-productlist",
  templateUrl: "./productlist.component.html",
  styleUrls: ["./productlist.component.css"],
})
export class ProductlistComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("showimport") showimport: any;
  @Output() clearEvent = new EventEmitter<void>();
  ProductHeader: string[] = ["Action"];
  sortData: any = { column: "ProductId", direction: "asc" };
  registerForm: FormGroup;
  dtOptions: any = {};
  businessStream: any = [];
  isFiltersRendered: boolean = false;

  businessCategory: any = [];
  businessCategoryList: any = [];
  selectedBusinessCategory: any = [];
  selectedBusinessCategoryId: string = "";

  productType: any = [];
  ProductTypeList: any = [];
  selectedProductType: any = [];
  selectedProductTypeId: string = "";

  productBrand: any = [];
  ProductBrandList: any = [];
  selectedProductBrand: any = [];
  selectedProductBrandId: string = "";

  productSeries: any = [];
  ProductSeriesList: any = [];
  selectedProductSeries: any = [];
  selectedProductSeriesId: string = "";

  productGroup: any = [];
  ProductGroupList: any = [];
  selectedProductGroup: any = [];
  selectedProductGroupId: string = "";

  dropdownSettings: any = {};
  dropdownSettings1: any = {};
  dropdownSettings2: any = {};
  dropdownSetting3: any = {};

  dropdownList: any;
  selectedItems = [];
  ProductHeaderCol: any;
  ProductHeaderKey = [];
  ProductList = [];
  showmodel: any = [];
  showModelArray: any = [];
  dataSource: any;
  Source: any;
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: number;
  searchword: any = "";
  TotalRecord: any;
  sortingProperty: string = "";
  ascDesType: string = "Descending";
  SortType: string = "desc";
  totalCount: number;
  showTable: boolean;
  permission: any;
  isCollapsed: boolean = false;
  isCollapsed1: boolean = false;
  submitted: boolean = false;
  ProductId: any;
  modalRef: any;
  deleteId: any;
  err_message: any;
  file: any;
  vertical: any;
  category: any;
  code: any;
  baseurl: any;
  addDocument: any;
  exportDoc: any;
  isExcelFile: boolean;
  inputFile: any;
  upfile: File;
  data: any[];
  showcompany: any = [];
  status_id: any;
  sta_type: any;
  productid: any;
  BusinessVerticalId: number;
  businessStreamArray: any = [];
  type: string;
  namesort: string;
  downicon: boolean = true;
  upicon: boolean = true;
  columnsort: any;
  id: any;
  Totalrec: any = 0;
  invalid: any = 0;
  valid: any = 0;
  dataarray: any = [];
  error: any = [];
  count: number = 0;
  isValid: boolean = false;
  modelref: BsModalRef;
  name: any;
  dataSheet = new Subject();
  productValues: any;
  verticalId: any;
  active: any;
  Sample_Product: string;
  exportBusiness: any;
  arrHeader: any = [];
  userRId: any;
  multiClick = false;
  headerkey: any;
  StatusForm: FormGroup;
  submitted1 = false;

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private changeDetectorRefs: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.active = localStorage.getItem("verticalId");
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    this.baseurl = environment.api_url;
    this.Sample_Product = environment.import_sample;
    this.isCollapsed = false;

    this.registerForm = this.formBuilder.group({
      SearchWord: [""],
      BusinessVertical: [""],
      BusinessCategory: [""],
      ProductGroup: [""],
      ProductType: [""],
      Brand: [""],
      ProductSeries: [""],
      ItemCode: [""],
    });

    this.StatusForm = this.formBuilder.group({
      Remark: ["", Validators.required],
    });

    this.BusinessVerticalId = 1;
    this.currentPage = 0;
    this.dynamicList();

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };
    this.dropdownSettings1 = {
      singleSelection: false,
      text: "Product Group",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSettings2 = {
      singleSelection: false,
      text: "Item Code",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting3 = {
      singleSelection: false,
      text: "Model / Item",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.productValues = {
      Brand: "ProductBrandName",
      Group: "ProductGroupName",
      Category: "CategoryName",
      Description: "Description",
      ItemCode: "Code",
      ProductType: "ProductTypeName",
      Series: "ProductSeriesName",
      Type: "ProTypeName",
      IsVatAllow: "IsVatAllowName",
      VatRate: "VatRate",
      Status: "StatusName",
      StatusRemark: "StatusRemark",
    };

    this.GetBusinessVertical();
  }

  onItemSelect(item: any) {}
  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  changeTab(event: any) {
    this.spinner.show();
    this.verticalId = parseInt(event.nextId.charAt(event.nextId.length - 1));
    localStorage.setItem("verticalId", this.verticalId);
    this.GetDetailsByBusinessVertical(this.verticalId);
    this.getModel(this.verticalId);
    this.BusinessVerticalId = this.verticalId;
    this.reset();
  }

  onBusinessCategorySelect(item: any) {
    this.selectedBusinessCategoryId = "";
    this.selectedBusinessCategory.forEach((element) => {
      this.selectedBusinessCategoryId += element["id"] + ", ";
    });
  }
  onProductGroupSelect(item: any) {
    this.selectedProductGroupId = "";
    this.selectedProductGroup.forEach((element) => {
      this.selectedProductGroupId += element["id"] + ", ";
    });
  }
  onProductTypeSelect(item: any) {
    this.selectedProductTypeId = "";
    this.selectedProductType.forEach((element) => {
      this.selectedProductTypeId += element["id"] + ", ";
    });
  }
  onProductBrandSelect(item: any) {
    this.selectedProductBrandId = "";
    this.selectedProductBrand.forEach((element) => {
      this.selectedProductBrandId += element["id"] + ", ";
    });
  }
  onProductSeriesSelect(item: any) {
    this.selectedProductSeriesId = "";
    this.selectedProductSeries.forEach((element) => {
      this.selectedProductSeriesId += element["id"] + ", ";
    });
  }

  GetDetailsByBusinessVertical(verticalId: number) {
    let data = { BusinessVerticalId: verticalId };
    this.isFiltersRendered = false;
    this.UserService.GetDetailsByBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.selectedBusinessCategory = [];
        this.selectedProductGroup = [];
        this.selectedProductType = [];
        this.selectedProductBrand = [];
        this.selectedProductSeries = [];
        this.selectedmodel = [];

        this.productGroup = [];
        res["ProductGroup"].forEach((element) => {
          this.productGroup.push({
            id: element.ProductGroupId,
            itemName: element.Name,
          });
        });

        this.productType = [];
        res["ProductType"].forEach((element) => {
          this.productType.push({
            id: element.ProductTypeId,
            itemName: element.Name,
          });
        });

        this.productBrand = [];
        res["ProductBrand"].forEach((element) => {
          this.productBrand.push({
            id: element.BrandId,
            itemName: element.Name,
          });
        });

        this.productSeries = [];
        res["ProductSeries"].forEach((element) => {
          this.productSeries.push({
            id: element.ProductSeriesId,
            itemName: element.Name,
          });
        });

        this.businessCategory = [];
        res["BusinessCategory"].forEach((element) => {
          this.businessCategory.push({
            id: element.BusinessCategoryId,
            itemName: element.Name,
          });
        });

        this.ProductHeader = [];
        this.ProductHeaderCol = res["ProductColumn"][0];
        this.ProductHeaderKey = [];

        for (let key in res["ProductColumn"][0]) {
          if (key != "BusinessVerticalId" && key != "ProductColumnId") {
            this.headerkey = Object.entries(res["ProductColumn"][0]);
            let objHeader = [];
            this.headerkey.forEach((element) => {
              objHeader.push(element[0]);
            });
            this.ProductHeader.push(res["ProductColumn"][0][key]);
            this.ProductHeaderKey.push(key);
          }
        }
        this.ProductHeader.push("Action");
        this.isFiltersRendered = true;
        this.currentPage = 0;
        this.dynamicList();
      }
    });
  }

  dynamicList() {
    let data = {
      BusinessVertical: this.BusinessVerticalId,
      SearchWord: this.searchword,
      BusinessCategory: this.selectedBusinessCategoryId,
      ProductGroup: this.selectedProductGroupId,
      ProductType: this.selectedProductTypeId,
      Brand: this.selectedProductBrandId,
      ProductSeries: this.selectedProductSeriesId,
      IsVatAllow: "",
      VatRate: "",
      Export: "",
      Sort: this.namesort,
      SortWise: this.type,
      ItemCode: this.selectedModelId,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Status: "1,2",
    };
    this.ProductList = [];
    this.UserService.ProductListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.ProductList = res["ContactList"];
        this.totalSize = res["TotalRecord"];
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.iterator();
      } else {
        this.toastrService.error(res["Msg"]);
        this.spinner.hide();
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  getModel(verticalId: number) {
    let data = { BusinessVerticalId: verticalId };
    this.showmodel = [];
    this.UserService.GetItemCodeByBV(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showModelArray = res;
        for (const item of this.showModelArray["ItemCode"]) {
          this.showmodel.push({
            id: item["ProductId"],
            itemName: item["Code"],
          });
        }
      } else {
        this.showModelArray = [];
      }
    });
  }
  selectedmodel: any = [];
  selectedModel: string = "";
  selectedModelId: string = "";
  onModelSelect(item: any) {
    this.selectedModel = "";
    this.selectedModelId = "";
    this.selectedmodel.forEach((element) => {
      this.selectedModel += element["itemName"] + ", ";
      this.selectedModelId += element["id"] + ", ";
    });
  }

  GetBusinessVertical() {
    let data = {};
    this.spinner.show();
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        let businessStreamArray = res;
        this.businessStream = [];
        for (const item of businessStreamArray["Data"]) {
          this.businessStream.push({
            id: item["Id"],
            itemName: item["Name"],
          });
        }
        this.GetDetailsByBusinessVertical(businessStreamArray["Data"][0]["Id"]);
        this.getModel(businessStreamArray["Data"][0]["Id"]);
        this.BusinessVerticalId = businessStreamArray["Data"][0]["Id"];
      } else {
        this.businessStream = [];
      }
      this.spinner.hide();
    });
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  openClose() {
    this.isCollapsed1 = !this.isCollapsed1;
  }

  edit(id) {
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    encryptid = encryptid.toString().replace("/", "FGH").replace("%", "NST");
    this.router.navigate(["/productmanagment/editproduct/" + encryptid]);
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    this.dynamicList();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.businessStreamArray.slice(start, end);
    this.dataSource = part;
  }

  onSortData(sort: Sort) {
    this.headerkey.forEach((element) => {
      if (element[1] == sort.active) {
        this.namesort = element[0];
      }
    });
    this.currentPage = 0;
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    this.currentPage = 0;
    this.dynamicList();
  }

  ExportOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }
  exportConfirm() {
    this.exportProduct();
    this.modalRef.hide();
  }
  exportProduct() {
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      BusinessVertical: parseInt(this.exportBusiness),
      BusinessCategory: this.selectedBusinessCategoryId,
      ProductGroup: this.selectedProductGroupId,
      ProductType: this.selectedProductTypeId,
      Brand: this.selectedProductBrandId,
      ProductSeries: this.selectedProductSeriesId,
      IsVatAllow: "",
      VatRate: "",
      Export: true,
      Sort: "",
      SortWise: "",
      ItemCode: this.selectedModelId,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
      Status: "1,2",
    };
    this.UserService.ProductListFilter(data).subscribe((res: any) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.spinner.hide();
        let exporturl = res["Data"];
        window.open(this.baseurl + "/" + exporturl);
      } else {
        this.spinner.hide();
        this.toastrService.error(res["Msg"]);
      }
    });
  }

  tt: any;
  onSubmit() {
    this.currentPage = 0;
    let data = {
      ProductId: this.ProductId,
      BusinessCategory: this.selectedBusinessCategoryId,
      BusinessVertical: this.BusinessVerticalId,
      ProductGroup: this.selectedProductGroupId,
      ProductType: this.selectedProductTypeId,
      Brand: this.selectedProductBrandId,
      ProductSeries: this.selectedProductSeriesId,
      ItemCode: this.selectedModelId,
      IsVatAllow: "",
      VatRate: "",
      Sort: "",
      SortWise: "",
      Export: "",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    if (this.registerForm.valid) {
      this.spinner.show();
      this.UserService.ProductListFilter(data).subscribe((res) => {
        if (res["result"] == "success") {
          this.toastrService.success(res["Msg"]);
          this.showTable = true;
          this.ProductList = res["ContactList"];
          this.totalSize = res["TotalRecord"];
          this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
          this.iterator();
          this.TotalRecord = res["TotalRecord"];
          this.tt = res["TotalRecord"];
          this.totalSize = this.TotalRecord;
          this.router.navigate(["/productmanagment/productlist"]);
        } else if (res["result"] == "Failed") {
          this.toastrService.error(res["Msg"]);
        } else {
          this.toastrService.error(res["Msg"]);
        }
        this.spinner.hide();
      });
    }
    this.submitted = true;
  }

  resetData() {
    this.selectedBusinessCategory = [];
    this.selectedProductGroup = [];
    this.selectedProductType = [];
    this.selectedProductBrand = [];
    this.selectedProductSeries = [];
    this.selectedmodel = [];
    this.selectedBusinessCategoryId = "";
    this.selectedProductGroupId = "";
    this.selectedProductTypeId = "";
    this.selectedProductBrandId = "";
    this.selectedProductSeriesId = "";
    this.selectedModelId = "";
    this.registerForm.reset();
    this.totalSize = this.tt;
    this.dynamicList();
    this.isCollapsed = true;
  }

  reset() {
    this.selectedBusinessCategory = [];
    this.selectedProductGroup = [];
    this.selectedProductType = [];
    this.selectedProductBrand = [];
    this.selectedProductSeries = [];
    this.selectedmodel = [];
    this.selectedBusinessCategoryId = "";
    this.selectedProductGroupId = "";
    this.selectedProductTypeId = "";
    this.selectedProductBrandId = "";
    this.selectedProductSeriesId = "";
    this.selectedModelId = "";
    this.registerForm.reset();
    this.totalSize = this.tt;
    this.searchword = "";
  }

  deleteOpenModal(
    template: TemplateRef<any>,
    Name,
    data,
    Vertical,
    Category,
    Code
  ) {
    if (data) {
      this.deleteId = data;
      this.file = Name;
      this.category = Vertical;
      this.vertical = Category;
      this.code = Code;
      this.modalRef = this.modalService.show(template, {
        class: "modal-md modal-dialog-centered",
      });
    }
  }

  decline() {
    this.modalRef.hide();
  }

  clear() {
    this.StatusForm.get("Remark").patchValue("");
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  deleteConfirm() {
    this.deleteProduct();
    this.modalRef.hide();
  }

  deleteProduct() {
    this.spinner.show();
    this.UserService.UpdateProductStatus({
      ProductId: this.file,
      Status: 3,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastrService.success("Product Deleted Successfully!");
        this.dynamicList();
      } else {
        this.err_message = response.Msg;
      }
    });
  }

  statusConfirm() {
    this.makeActiveInactive();
    this.modalRef.hide();
  }
  modeldisplay3: any = false;
  applyback: any;
  openStatusModel(
    template: TemplateRef<any>,
    ProductId: any,
    Status: any,
    Vertical,
    Category,
    Code
  ) {
    this.status_id = ProductId;
    this.file = Vertical;
    this.vertical = Category;
    this.code = Code;
    this.sta_type = Status;
    this.modeldisplay3 = true;
    this.applyback = true;
    this.modalRef = this.modalService.show(template, {
      class: "modal-md modal-dialog-centered",
    });
  }

  hidemodel2() {
    this.modeldisplay3 = false;
  }

  makeActiveInactive() {
    this.submitted1 = true;
    if (this.StatusForm.valid) {
      const data = {
        ProductId: this.status_id,
        Status: this.sta_type,
        StatusRemark: this.StatusForm.value.Remark,
      };
      this.spinner.show();
      this.UserService.UpdateProductStatus(data).subscribe(
        (res: any) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastrService.success(res["Msg"], "Success!");
            this.modalRef.hide();
            this.modeldisplay3 = false;
            this.router
              .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigateByUrl("/productmanagment/productlist");
              });
          } else {
            this.err_message = res.Msg;
            this.spinner.hide();
          }
        },
        (err: any) => {
          this.spinner.hide();
        }
      );
      this.submitted1 = false;
    }
  }

  onChange(evt) {
    let data, header;
    const target: DataTransfer = <DataTransfer>evt.target;
    const regex = /(.xls|.xlsx)/;
    this.isExcelFile = !!regex.exec(target.files[0].name);

    if (!this.isExcelFile) {
      this.toastr.error("Invaild File Format. Only xlsx Files Are Allowed !");
      return;
    }
    this.upfile = target.files[0];
    if (target.files.length > 1) {
      this.inputFile.nativeElement.value = "";
    }
    if (this.isExcelFile) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* for header */
        let arrHeaderMain = wb["Sheets"][wsname];
        this.arrHeader = [];
        if (arrHeaderMain == undefined || arrHeaderMain == null) {
          this.count = 0;
        } else {
          this.arrHeader.push(arrHeaderMain.A1?.h);
          this.arrHeader.push(arrHeaderMain.B1?.h);
          this.arrHeader.push(arrHeaderMain.C1?.h);
          this.arrHeader.push(arrHeaderMain.D1?.h);
          this.arrHeader.push(arrHeaderMain.E1?.h);
          this.arrHeader.push(arrHeaderMain.F1?.h);
          this.arrHeader.push(arrHeaderMain.G1?.h);
          this.arrHeader.push(arrHeaderMain.H1?.h);
          this.arrHeader.push(arrHeaderMain.I1?.h);
          this.arrHeader.push(arrHeaderMain.J1?.h);
          this.arrHeader.push(arrHeaderMain.K1?.h);
        }

        /* save data */
        this.data = XLSX.utils.sheet_to_json(ws);
      };
      reader.readAsBinaryString(target.files[0]);

      reader.onloadend = (e) => {
        this.showcompany = Object.keys(this.data);
        this.dataSheet.next(this.data);
        this.count = 0;
        let arr = [
          "BusinessVertical",
          "BusinessCategory",
          "ProductGroup",
          "ProductType",
          "ProductBrand",
          "ProductSeries",
          "Type",
          "ItemCode",
          "ProductDescription",
          "IsVatAllow",
          "VatRate",
        ];

        if (
          JSON.stringify(this.arrHeader) === JSON.stringify(arr) &&
          this.arrHeader.length > 0
        ) {
          if (this.showcompany.length > 0) {
            if (this.showcompany.length <= 1000) {
              this.count = 2;
            } else {
              this.count = 3;
            }
          } else {
            this.count = 1;
          }
        } else {
          this.count = 0;
        }
      };
    } else {
      this.inputFile.nativeElement.value = "";
    }
  }

  import() {
    if (this.data == undefined) {
      this.toastr.error("Please Select a valid xlsx file");
      return null;
    } else if (this.count == 0) {
      this.toastr.error("Invalid Template!");
      return;
    } else if (this.count == 1) {
      this.toastr.error("File should not be empty !");
      return;
    } else if (this.count == 3) {
      this.toastr.error("Maximum 1000 records are allowed !");
      return;
    } else {
      this.multiClick = true;
      this.spinner.show();
      this.UserService.ImportProductList(this.data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.showimport.nativeElement.click();
            this.Totalrec = res["TotalRecord"];
            this.invalid = res["InvaildRow"];
            this.valid = this.Totalrec - this.invalid;
            this.dataarray = res["Data"];
            this.toastr.success(res["Msg"]);
          } else if (res["result"] == "Failed") {
            this.spinner.hide();
            this.showimport.nativeElement.click();
            this.isValid = true;
            this.Totalrec = res["TotalRecord"];
            this.invalid = res["InvaildRow"];
            this.valid = this.Totalrec - this.invalid;
            this.dataarray = res["Data"];
            this.toastr.error(res["Msg"]);
          } else {
            this.toastr.error(res["Msg"]);
            this.spinner.hide();
          }
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
            this.multiClick = false;
          }
        }
      );
    }
  }

  rtnView() {
    this.router
      .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => {
        this.router.navigateByUrl("/productmanagment/productlist");
      });
  }
}
